export const GET_CONFIGURATION: string = 'GET_CONFIGURATION';
export const GET_CONFIGURATION_SUCCESS: string = 'GET_CONFIGURATION_SUCCESS';